<template>
  <div>
    <el-dialog title="用户地址" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
               :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
               style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
               @close="dialogClose" v-el-drag-dialog v-el-dialog-center>

      <!-- 品牌信息 -->
      <div class="detail-wrap">
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>用户地址</b>
            </div>
            <table class="table-detail">
              <tbody>

              <tr>
                <th>
                  <em class="f-red">*</em>
                  联系人
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.custName" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  联系方式
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.custMobile" clearable/>
                </td>

                <th>
                  其他电话1
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.custPhone1" clearable/>
                </td>

                <th>
                  其他电话2
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.custPhone2" clearable/>
                </td>

                
              </tr>
              <div style="height: 5px;"></div>
              <tr>
                <th>
                  地址
                </th>
                <td colspan="3">
                  <template>
                        <el-cascader    :props="areaProps" v-model="areaValues" clearable style="width: 473px !important;;" filterable  
                                     
                                  
                                     :before-filter="areaBeforeFilter"
                                     @myInput="handleInput"
                                     @change="handleChange" ref="cascaderAddr" :options="areaOption">
                        </el-cascader>
        
                      </template>
                </td>

                <th>
                  详细地址
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.custAddress" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  是否默认地址
                </th>
                <td>
                  <el-select v-model="formData.isDefault" clearable>
                    <el-option label="否" :value="0"/>
                    <el-option label="是" :value="1"/>
                  </el-select>
                </td>
              </tr>


              </tbody>
            </table>
          </div>


        </div>
      </div>
      <span slot="footer" class="dialog-footer">
			  <el-button type="primary" plain class="button-sty" @click="dialogClose">
				  <i class="el-icon-close el-icon"></i>
				  取 消
			  </el-button>
			  <el-button type="primary" @click="commitData" class="button-sty">
				  <i class="el-icon-check el-icon"></i>
				  确 定
			  </el-button>
		  </span>
    </el-dialog>

  </div>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import pager from '@/components/pager/index.vue';
import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';
import orderDialog from '@/views/dialogCommon/radioOrderDialog.vue';
import api from "@/api/projectApi";

export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param', 'areaObj'],
  mixins: [selectDialogMixins],
  components: {preconditionDialog, pager, orderDialog},

  created() {
    this.initSetting()
    if (this.areaObj != null) {
      this.formData = this.areaObj
      if (!this.formData.isNew) {
        this.formData.isNew = false
      }
    }
  },

  watch: {},

  mounted() {
    this.echoAddress()
  },

  computed: {},

  data() {
    return {
      showArea:true,

      areaValues: [],
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      area: {
        country: null,
        province: null,
        city: null,
        county: null,
        town: null,
      },
      areaOption: [],

      dataId: 0,


      formData: {
        id: null,
        profileId: 0,  // 用户档案Id,关联bas_cust_profile.id
        custName:null,
        custMobile: null,  // 联系方式
        custPhone1: null,  // 其他电话1
        custPhone2: null,  // 其他电话2
        custProvince: null,  // 省
        custCity: null,  // 市
        custCounty: null,  // 县
        custTown: null,  // 街道
        areaId: null,  // 关联xx_area.id
        custAddress: null,  // 详细地址
        isDefault: 0,  // 是否默认地址;0否1是
        isNew: true
      },
      showOrderDialog: false,
      showDialog: true,
      falseValue: false,
      selectMulti: true,

    };
  },


  methods: {
    // 当前页面确认按钮逻辑
    commitData() {
      if (this.formData.custName == null || this.formData.custName == '') {
        this.$message.warning('联系人不能为空')
        return
      }
      if (this.formData.custMobile == null || this.formData.custMobile == '') {
        this.$message.warning('联系方式不能为空')
        return
      }
      if (this.formData.isDefault == null) {
        this.$message.warning('是否为默认地址不能为空')
        return
      }

      if (!this.formData.id) {
        this.formData.id = new Date().getTime()
      }

      this.formData.custCountry = this.area.country
      this.formData.custProvince = this.area.province
      this.formData.custCity = this.area.city
      this.formData.custCounty = this.area.county
      this.formData.custTown = this.area.town

      console.log('地址弹框数据: ', this.formData)
      this.$emit('commitData', this.formData)
      this.dialogClose()
    },

    handleChange() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (this.keyWord) {
        this.clear()
        this.area.areaId = areaNode[0].value;
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: {id: this.area.areaId}
        }).then(res => {
          // console.log(res)
          this.areaOption = res.data.data.options
          this.areaValues = res.data.data.values
          // this.area = res.data.data.names
        })
      }
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.area.country = areaNode[0].label;
          this.area.province = null;
          this.area.city = null;
          this.area.county = null;
          this.area.town = null;
        } else if (areaNode[0].level == 2) {
          this.area.province = areaNode[0].label;
          this.area.city = null;
          this.area.county = null;
          this.area.town = null;
        } else if (areaNode[0].level == 3) {
          this.area.city = areaNode[0].label;
          this.area.county = null;
          this.area.town = null;
        } else if (areaNode[0].level == 4) {
          this.area.county = areaNode[0].label;
          this.area.town = null;
        } else if (areaNode[0].level == 5) {
          this.area.town = areaNode[0].label;
        }
        this.formData.areaId = areaNode[0].value
      } else {
        this.formData.areaId = null
        this.area.country = null;
        this.area.province = null;
        this.area.city = null;
        this.area.county = null;
        this.area.town = null;
      }

      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },

    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.area.areaId = node.value;
      this.resetInput()
      let params = {parentId: node.value}
      if (this.keyWord) { //如果有关键词，带上关键词获取，需要接口支持
        params ={
          areaName:this.keyWord,
          parentId: node.value
        }
      }


      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        let node0 = []
        if (this.keyWord) {
          this.$refs.cascaderAddr.inputValue = this.keyWord
          this.$refs.cascaderAddr.$refs.input.focus()
          this.$refs.cascaderAddr.toggleDropDownVisible()
          resolve(node0)
        }
        console.log()
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },






    // 地址三级联动

    //输入时获取关键词，主要用于判断用户何时清空了关键词
    handleInput(val) {
      this.inputWord = val
    },
    areaBeforeFilter(value){
      console.log("value=====",value)
      this.keyWord = value
      let params = {}
      if (this.keyWord) { //如果有关键词，带上关键词获取，需要接口支持
        params ={
          areaName:this.keyWord,
     
        }
      }

      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: params,
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        let node0 = []
        if (this.keyWord) {
          this.$refs.cascaderAddr.inputValue = this.keyWord
          this.$refs.cascaderAddr.$refs.input.focus()
          this.$refs.cascaderAddr.toggleDropDownVisible()
       
        }
        const childrens = response.data.data || {};
        console.log(childrens,"254  得到了请求数据");
       

          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          this.areaOption = childNodes
       

      })


      this.key++
      return false
    },
    resetInput() {
      this.$nextTick(() => {
        const that = this.$refs.cascaderAddr
        this.$refs.cascaderAddr.handleInput = function(val, event) {
          that.$emit('myInput', val)
          !that.dropDownVisible && that.toggleDropDownVisible(true)
          if (event && event.isComposing) return
          if (val) {
            that.filterHandler()
          } else {
            that.filtering = false
          }
        }
      })
    },
// 清空选中时，重置下拉选项，清空输入，默认展开下拉面板
    clear() {
      console.log("11111222")
      this.keyWord = ''
      // this.key++
      // this.$nextTick(() => {
      //   this.$refs.cascaderAddr.$refs.input.focus()
      //   this.$refs.cascaderAddr.toggleDropDownVisible()
      // })
    },











    // 地址数据回显
    echoAddress() {
      if (this.formData.areaId !== null && this.formData.areaId !== '' && this.formData.areaId !== 0) {
        // this.cascaderShow = false
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: {id: this.formData.areaId}
        }).then(res => {
          // console.log(res)
          this.areaOption = res.data.data.options
          this.areaValues = res.data.data.values
          this.area = res.data.data.names
        })
      }
    },




  }
};
</script>
<style lang="scss" scoped>
.papers {
  position: absolute;
  left: 292px;
  top: 0px;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

// ::v-deep .el-dialog {
//     margin-top: 110px !important;
//     overflow: hidden;
// }


.d-item {
  border: 1px solid #ededed;
}

.table-detail {
  padding-left: 35px;
  display: inline-block;
}

.table-detail tr {
  margin-bottom: 10px;
  display: inline-block;

  th {
    font-weight: 400;
    text-align: right;
    width: 112px;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);

  }

  // td{
  // 	display: inline-block;
  // 	width: 170px !important;
  // }
}



.title b {
  display: inline-block;
  line-height: 28px;
  font-size: 16px;
  font-weight: 600;
  margin-right: 84px;
  vertical-align: middle;
  color: #00c4b3;
  position: relative;
  z-index: 2;
  background: rgba(42, 100, 148, 0.16);
  margin-left: 0px;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 14px;
  border-radius: 0 28px 28px 0;
}

.detail-wrap {
  background-color: #fff;
  padding: 5px;
}

// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 570px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

.btn_zdy {
  margin: 10px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  // margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

.vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -50px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

</style>
